import React, { Suspense, useRef, useState, useEffect } from "react"
import { Canvas, useFrame, useLoader } from "@react-three/fiber"
import { ContactShadows, Environment, useGLTF, OrbitControls, PointerLockControls, PerspectiveCamera, Text, useProgress } from "@react-three/drei"
import { VRCanvas, useXR, Hands, DefaultXRControllers } from '@react-three/xr'
import { Vector3 } from 'three'
import { PCDLoader } from 'three-stdlib'
import { Stars } from './StarsVR'

import Player from './Player'
import Room from './Room'
import { VRButton } from "./VRButton"



function Loader() {
  const { progress } = useProgress()
  return <Text position={[0, 1, -3]} center>Loading super big point clouds...</Text>
}


export default function App() {
  const controlsRef = useRef()
  const orbitControlsRef = useRef()

  return (
    <>
      <VRCanvas dpr={[1, 1.5]} camera={{ position: [0, 0, -4], fov: 50 }} onCreated={({ gl }) => {
        VRButton.createButton(gl)
      }}>
        <Stars />
        <Hands />
        <DefaultXRControllers />
        <Player controlsRef={controlsRef} orbitControlsRef={orbitControlsRef} />
        <ambientLight intensity={0.1} />
        <pointLight intensity={10} angle={0.1} penumbra={1} position={[0, 6, 0]} castShadow />
        <Suspense fallback={<Loader />}>
          {/* <Loader></Loader> */}
          <Room />
          {/* <Environment path="" files="potsdamer_platz_1k.hdr" /> */}
          {/* <ContactShadows rotation-x={Math.PI / 2} position={[0, -0.8, 0]} opacity={0.25} width={10} height={10} blur={1.5} far={0.8} /> */}
        </Suspense>
        <PointerLockControls ref={controlsRef} selector="#enterflat" />
        <OrbitControls ref={orbitControlsRef} enableZoom={true} target={[0, 1, -2]} enablePan={false} enabled={true} />
      </VRCanvas>
    </>
  )
}
